import * as ActionType from '../constants/ActionType'
import * as api from '../api/api';
import { push } from 'react-router-redux';
import {fetchUserStatus} from "./user";

export function getCart() {
    return (dispatch, getState) => {

        if ( isCartLoaded(getState()) ) {

            // Let the calling code know there's nothing to wait for.
            return Promise.resolve();
        } else {
            // Dispatch a thunk from thunk!
             return dispatch(fetchCart());
        }
    };
}

export function updateItem(documentStorageId, quantity) {
    return (dispatch, getState) => {

        dispatch(requestUpdateItem());

        api.updateCartItem(documentStorageId, quantity)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json => {
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                dispatch(receiveCart(json))
            })
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;
    };
}

export function requestApprovalForItem(documentStorageId) {
    return (dispatch, getState) => {

        dispatch(requestApproval());

        api.requestApproval(documentStorageId)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json => {
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                dispatch(receiveApprovalSuccess(json))
            })
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;
    };
}

export function processCart(cartData) {
    return (dispatch, getState) => {

        dispatch(requestProcessCart());

        api.processCart(cartData)
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json => {
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                dispatch(receiveProcessCart(json))
                dispatch(fetchUserStatus())
            })
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;
    };
}

export function closeProcessCart() {
    return (dispatch, getState) => {
        dispatch(endProcessCart());
    }
}

function requestCart() {
    return {
        type: ActionType.REQUEST_CART
    }
}

function receiveCart(payload) {
    return {
        type: ActionType.RECEIVE_CART,
        payload: payload
    }
}

function receiveApprovalSuccess(payload) {
    return {
        type: ActionType.RECEIVE_APPROVAL_SUCCESS,
        payload: payload
    }
}

export function receiveApprovalSuccessHide(payload) {
    return {
        type: ActionType.RECEIVE_APPROVAL_SUCCESS_HIDE
    }
}

function fetchCart() {
    // Thunk middleware knows how to handle functions.
    // It passes the dispatch method as an argument to the function,
    // thus making it able to dispatch actions itself.

    return function (dispatch, getState) {

        dispatch(requestCart());

        api.getCart()
            .then(function(response) {
                return api.handleStatus(response, dispatch)
            })
            .then(json =>
                // We can dispatch many times!
                // Here, we update the app state with the results of the API call.
                dispatch(receiveCart(json))
            )
        // .catch(error => {
        //     console.log(`Request failed: ${error}`);
        // })
        ;

        // In a real world app, you also want to
        // catch any error in the network call.
    }
}

function isCartLoaded(globalState) {
    if (globalState.cart.loaded === false) {
        return false;
    }

    return true;
}

function requestUpdateItem() {
    return {
        type: ActionType.UPDATE_CART_ITEM
    }
}

function requestApproval() {
    return {
        type: ActionType.REQUEST_APPROVAL
    }
}

function requestProcessCart() {
    return {
        type: ActionType.REQUEST_PROCESS_CART
    }
}

function receiveProcessCart(payload) {
    return {
        type: ActionType.RECEIVE_PROCESS_CART,
        payload: payload
    }
}

function endProcessCart() {
    return {
        type: ActionType.END_PROCESS_CART
    }
}



// WEBPACK FOOTER //
// ./src/js/actions/cart.js